import type { ReactNode } from "react";

interface PhoneMockProps {
  children: ReactNode;
  className?: string;
}

export function PhoneMock({ children, className = "" }: PhoneMockProps) {
  return (
    <div
      className={`relative mx-auto w-[280px] rounded-[2.75rem] border-[10px] border-ink bg-ink p-1.5 shadow-2xl ${className}`}
    >
      <div className="absolute left-1/2 top-2 z-10 h-5 w-24 -translate-x-1/2 rounded-full bg-ink" />
      <div className="min-h-[560px] overflow-hidden rounded-[2rem] bg-cream-deep">
        <div className="flex items-center justify-between px-5 pb-2 pt-4 text-[11px] font-semibold text-ink">
          <span>13:20</span>
          <span className="flex gap-1 opacity-70">📶 🔋</span>
        </div>
        <div className="px-4 pb-6">{children}</div>
      </div>
    </div>
  );
}
